import { useQuery } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useMobile } from '@/common/composables/application';
import { useAuthStore } from '@/common/stores/auth';
import { storage } from '@/helpers/local-storage';
import { userPreferenceQueryOptions, useUserPreferenceUpdateMutation } from '@/queries/user-preference';

export const useSidebarStore = defineStore('sidebar', () => {
  const { isMobile } = useMobile();
  const authStore = useAuthStore();

  const { data: sideBarCollapsePreference } = useQuery({
    ...userPreferenceQueryOptions<boolean>('sideBarCollapse'),
    enabled: authStore.isUserLogged,
  });
  const { mutate: mutateSideBarCollapsePreferenceUpdate } = useUserPreferenceUpdateMutation('sideBarCollapse');

  const collapsed = storage.get<boolean>('sidebar-collapsed') ? ref(true) : isMobile.value ? ref(true) : ref(false);

  const toggleSidebar = () => {
    document.body.style.setProperty('--sidebar-width', collapsed.value ? '50px' : '277px');
    storage.set<boolean>('sidebar-collapsed', collapsed.value);
    if (authStore.isUserLogged) {
      mutateSideBarCollapsePreferenceUpdate(collapsed.value);
    }
  };

  return {
    collapsed,
    sideBarCollapsePreference,
    toggleSidebar,
  };
});
